import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { MediaBreakPointUp, Colors } from '../styles';
import { ArrowDirection, ArrowIconWithMargin, Button, ButtonType, CautionIcon } from '../atoms';
import { Link } from 'react-router-dom';
import { LessonType, routes } from '@lean-body/src/route';
import { SettingItemKeys } from './setting_menu';
import { MovieIcon } from '../atoms/icons/movie_icon';
export const UnsubscribeWarning = ({ payment, profile, unsubscribeCationLessons }) => {
    const name = profile.userName && `${profile.userName}さんは`;
    let planRevenue;
    let planComparison;
    if (payment.currentPlan.isCampaignPlan()) {
        planRevenue = 'assets/images/unsubscribe_caution/cp.jpg';
        planComparison = 'assets/images/unsubscribe_caution/cp_comparison.png';
    }
    else if (payment.currentPlan.isAnnualPlan()) {
        planRevenue = 'assets/images/unsubscribe_caution/annual.jpg';
        planComparison = 'assets/images/unsubscribe_caution/annual_comparison.png';
    }
    else {
        planRevenue = 'assets/images/unsubscribe_caution/standard.jpg?20240808';
        planComparison = 'assets/images/unsubscribe_caution/standard_comparison.png';
    }
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement(CautionIcon, { classObject: styles.icon }),
        React.createElement("div", { className: css(styles.description) },
            name,
            "\u4ECA\u9000\u4F1A\u3092\u624B\u7D9A\u304D\u3092\u3057\u3066\u3082\u3042\u3068",
            React.createElement("span", { className: css(styles.descriptionAccent) }, payment.periodEndDiffFromNow()),
            "\u65E5\u3001\u6B21\u306E\u66F4\u65B0\u65E5\u307E\u3067LEAN BODY\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002"),
        React.createElement("div", { className: css(styles.warn) }, "\u203B\u9000\u4F1A\u3059\u308B\u3068\u3001\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u308B\u30B5\u30FC\u30D3\u30B9\u306B\u5F71\u97FF\u304C\u3042\u308A\u307E\u3059\u3002"),
        React.createElement("div", { className: css(styles.keepLeavingContainer) },
            React.createElement("div", { className: css(styles.section) },
                React.createElement("img", { className: css(styles.image), src: planRevenue })),
            React.createElement("div", { className: css(styles.section) },
                React.createElement("div", { className: css(styles.sectionTitle) }, "\u898B\u9003\u3057\u3066\u3044\u308B\u52D5\u753B\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F"),
                React.createElement("div", { className: css(styles.lessons) }, unsubscribeCationLessons.map((v, i) => (React.createElement(Link, { className: css(styles.lessonsItem), to: routes.LESSON.compile({ slug: v.lesson.slug, type: LessonType.normal }), key: i },
                    React.createElement("img", { className: css(styles.lessonsItemImg), src: v.lesson.thumbnailURL }),
                    React.createElement("div", { className: css(styles.lessonsItemTitle) },
                        v.title,
                        React.createElement(ArrowIconWithMargin, { classObject: styles.arrowIcon, direction: ArrowDirection.right, color: Colors.Black })),
                    React.createElement("div", { className: css(styles.lessonsItemDesc) }, v.description)))))),
            React.createElement("div", { className: css(styles.section) },
                React.createElement("div", { className: css(styles.sectionTitle) }, "LEAN BODY\u3067\u3067\u304D\u308B\u3053\u3068"),
                React.createElement("img", { className: css(styles.image), src: "assets/images/unsubscribe_caution/available.jpg" })),
            React.createElement("div", { className: css(styles.section) },
                React.createElement("div", { className: css(styles.sectionTitle) }, "LEAN BODY\u306A\u30891000\u672C\u4EE5\u4E0A\u306E\u30EC\u30C3\u30B9\u30F3\u3092\u53D7\u3051\u653E\u984C\u3067\u5727\u5012\u7684\u306B\u304A\u624B\u8EFD\uD83D\uDCB0\uD83C\uDF1F"),
                React.createElement("img", { className: css(styles.image), src: planComparison })),
            React.createElement("div", { className: css(styles.rerunVideoTitle) }, "\uFF3C\u9000\u4F1A\u624B\u7D9A\u304D\u306E\u524D\u306B\uFF01\uFF0F"),
            React.createElement(Link, { to: routes.SEARCH.compile() },
                React.createElement(Button, { className: css(styles.button), isRadius: true, fullWidth: true, buttonType: ButtonType.primary },
                    React.createElement(MovieIcon, { classObject: styles.movieIcon }),
                    "\u898B\u9003\u3057\u3066\u3044\u308B\u52D5\u753B\u3092",
                    React.createElement("br", null),
                    "\u30C1\u30A7\u30C3\u30AF\u3059\u308B")),
            React.createElement(Link, { className: css(styles.checkPlan), to: `${routes.SETTING.compile()}?key=${SettingItemKeys.plan}` },
                React.createElement(Button, { className: css(styles.button), isRadius: true, fullWidth: true, buttonType: ButtonType.secondary }, "\u30D7\u30E9\u30F3\u3092\u5909\u66F4\u3059\u308B")))));
};
const styles = StyleSheet.create({
    container: {},
    icon: {
        width: 37,
        height: 35,
        margin: '0 auto 20px',
        display: 'block',
    },
    description: {
        color: Colors.Black,
        fontWeight: 500,
        lineHeight: '160%',
        letterSpacing: '1.28px',
    },
    descriptionAccent: {
        fontWeight: 'bold',
        color: Colors.Accent,
    },
    warn: {
        color: Colors.Accent,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: '0.56px',
        margin: '20px 0 0',
    },
    keepLeavingContainer: {
        [MediaBreakPointUp.MD]: {
            width: 315,
            margin: '0 auto',
        },
    },
    image: {
        width: '100%',
    },
    section: {
        margin: '40px 0',
    },
    sectionTitle: {
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: '1.28px',
        marginBottom: 10,
    },
    rerunVideoTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: '0.48px',
        color: Colors.PrimaryDarkB,
        textAlign: 'center',
        marginBottom: 4,
    },
    button: {
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: '0.56px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px 0',
        height: 60,
        marginBottom: 30,
    },
    movieIcon: {
        marginRight: 10,
    },
    checkPlan: {
        color: Colors.Black,
        fontSize: 12,
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    lessons: {
        padding: 12,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 20,
        justifyContent: 'space-between',
        borderRadius: 14,
        background: Colors.PrimaryLighter,
    },
    lessonsItem: {
        color: Colors.Black,
        width: 'calc(50% - 10px)',
    },
    lessonsItemImg: {
        width: '100%',
        borderRadius: 4,
    },
    lessonsItemTitle: {
        margin: '6px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.12,
    },
    lessonsItemDesc: {
        fontSize: 10,
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: 0.8,
    },
    arrowIcon: {
        width: 18,
        height: 18,
    },
});
